import React, { useState } from 'react'
import Button from '../components/Button';

// Data array for accordion items


// Accordion Item Component
const AccordionItem = ({ item, isOpen, onToggle }) => {
    return (
        <div className="border-b border-gray-300 dark:border-gray-600">
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between py-6 text-left hover:bg-gray-50 dark:hover:bg-black/50 px-5 transition-colors duration-200"
            >
                <span className="text-lg font-medium text-gray-900 dark:text-white pr-4">
                    {item.title}
                </span>
                <div className="flex-shrink-0">
                    <svg
                        className={`w-6 h-6 text-gray-600 dark:text-gray-300 transition-transform duration-200 ${isOpen ? 'rotate-45' : 'rotate-0'
                            }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                    </svg>
                </div>
            </button>

            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
                    }`}
            >
                <div className="text-gray-600 mt-5 px-5 dark:text-gray-300 space-y-2 text-base leading-relaxed pr-8">

                    {
                        item.content.map((p, index) => {
                            return (
                                <>
                                    <p key={index}>

                                        {p}
                                    </p>
                                </>
                            )
                        })
                    }

                    <Button className={"mt-7"}>Let's Talk</Button>

                </div>
            </div>
        </div>
    );
};

const BrandingExtraSection2 = ({data}) => {
    const [openItems, setOpenItems] = useState(new Set());

    const toggleItem = (itemId) => {
        const newOpenItems = new Set(openItems);
        if (newOpenItems.has(itemId)) {
            newOpenItems.delete(itemId);
        } else {
            newOpenItems.add(itemId);
        }
        setOpenItems(newOpenItems);
    };

    return (
        <div className="w-full bg-white dark:bg-zinc-900 relative z-20 dark:text-white py-20 px-35 pointer-events-auto">
            <div className=" mx-auto">
                {/* Header */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#EE005B] mb-2">
                        {data.heading}
                    </h2>
                </div>

                {/* Accordion */}
                <div className="space-y-0">
                    {data.accordionData.map((item) => (
                        <AccordionItem
                            key={item.id}
                            item={item}
                            isOpen={openItems.has(item.id)}
                            onToggle={() => toggleItem(item.id)}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BrandingExtraSection2